import { Component, OnInit } from '@angular/core';
import { SectionBase } from '../../../components/section/section-base';
import { OfferModificationsService } from '../../../../core/services/impl/offer-modifications/offer-modifications.service';
import { OfferModification } from '../../../../core/models/offer/offer-modification.model';
import { BusinessParamName } from '../../../models/request-offer/request-offer.enum';
import { InsuranceCompanyCode } from '../../../models/insurance-company-code.enum';
import { LanguageService } from '../../../services/language.service';
import { ApplicationStateService } from '../../../services/application-state.service';
import { OfferModificationCode } from '../../../../core/consts/offer-modification-code.enum';
import { OfferModificationDestination } from '../../../../core/consts/offer-modification-destination.enum';
import { AcVariantsBeesafeSectionConfigSectionConfig } from './ac-variants-beesafe-section.config';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { AcVariantsComparisonsDialogComponent } from './ac-variants-comparisons-dialog/ac-variants-comparisons-dialog.component';
import { MatDialog } from '@angular/material';
import { visibleInCustomWidth } from '../../../../core/utils/utils';
import {
  OfferModificationConfig,
  OfferModificationsConfigService
} from '../../../../core/services/impl/offer-modifications/offer-modifications-config.service';

@Component({
  selector: 'app-ac-variants-beesafe-section',
  templateUrl: './ac-variants-beesafe-section.component.html',
  styleUrls: ['./ac-variants-beesafe-section.component.scss']
})
export class AcVariantsBeesafeSectionComponent extends SectionBase implements OnInit {

  modificationsConfigs: OfferModificationConfig[];
  modifications: OfferModification[];
  sectionVisible: boolean;

  get visibleModifications(): OfferModification[] {
    return this.modifications.filter(mod => mod.visible);
  }

  get isTableVisible(): boolean {
    return visibleInCustomWidth(1352);
  }

  constructor(private languageService: LanguageService,
              private dialog: MatDialog,
              public offerModificationsService: OfferModificationsService,
              private configService: OfferModificationsConfigService,
              public stateService: ApplicationStateService) {
    super();
  }

  ngOnInit() {
    this.initModifications();
    this.initSectionVisible();
    if (this.sectionVisible) {
      this.initBean();
      this.createConfig(true);
      this.buildForm();
      this.initControlsChanges();
    }
  }

  createConfig(initialConfig = false): void {
    const priceFrequency = this.offerModificationsService.getCorrectPriceFrequency();
    const config = new AcVariantsBeesafeSectionConfigSectionConfig(this.languageService, this.offerModificationsService, priceFrequency);
    this.formConfig = config.createConfig(OfferModificationDestination.AC_VARIANTS, this.modifications, false, initialConfig);
  }

  initBean(): void {
    this.bean = {};
    this.modifications.forEach(modification => {
      const selectedOption = modification.options.find(option => option.selected);
      if (selectedOption) {
        this.bean[modification.code] = selectedOption.value;
      }
    });

    if (this.offerModificationsService.vehicleValueModificationEnabled) {
      this.bean.vehicleValue = this.offerModificationsService.getSelectedOfferVehicleValue() + '';
    }
  }

  initControlsChanges(): void {
    this.modifications.forEach(modification => this.getControl(modification.code).valueChanges.subscribe(value => {
      this.offerModificationsService.updateModification(modification.code, value);
      this.offerModificationsService.saveModificationInCache();
      this.offerModificationsService.setOfferCurrentPrice();
      this.offerModificationsService.modifiedOfferEvent.emit();
    }));

    if (this.offerModificationsService.vehicleValueModificationEnabled) {
      this.getControl('vehicleValue').valueChanges.subscribe(vehicleValue => {

      });
    }
  }

  compareAcCoveragesDialog() {
    this.dialog.open(AcVariantsComparisonsDialogComponent, AcVariantsComparisonsDialogComponent.getConfigBuilder()
      .buildConfiguration(this.offerModificationsService.getACPricing()))
      .afterClosed().subscribe(assistanceVariant => {
      if (isNotNullOrUndefined(assistanceVariant)) {
        this.getControl(OfferModificationCode.AC).setValue(assistanceVariant);
      }
    });
  }

  private initModifications(): void {
    if (this.offerModificationsService.modifications && this.offerModificationsService.modifications.length > 0) {
      this.modificationsConfigs = this.configService.getModificationsForDestination(OfferModificationDestination.AC_VARIANTS);
      const codes = this.modificationsConfigs.map(config => config.code);
      this.modifications = this.offerModificationsService.modifications.filter(modification => codes.includes(<OfferModificationCode>modification.code));
      this.sectionVisible = this.modifications && this.modifications.length > 0;
    }
  }

  private initSectionVisible(): void {
    const isBeesafe = this.stateService.getBusinessParameterValue(BusinessParamName.INSURANCE_COMPANY_CODE) === InsuranceCompanyCode.BEESAFE;
    this.sectionVisible = isBeesafe && this.modifications && this.modifications.length > 0;
  }

}
